import Vue from 'vue';
import Vue2Storage from 'vue2-storage';

Vue.use(Vue2Storage);

export default {
    mutations: {
        setRents(state, rents) {
            state.rents = rents;
        }
    },
    state: {
        rents: null,
    },
    getters: {
        getRents(state) {
            return state.rents;
        },
    }
}